module.exports = __webpack_public_path__ + "static/media/plaid_cng_example.7f2bf60a.png";